import React from 'react';
import { Car, Sparkles, Home } from 'lucide-react';
import { platformData } from '../../data/mock';

const iconMap = {
  Car: Car,
  Sparkles: Sparkles,
  Home: Home
};

const ValueProposition = () => {
  return (
    <section id="about" className="py-24 bg-white relative">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            What's Inside This Guide
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Three proven platforms, one comprehensive strategy for building lasting wealth
          </p>
        </div>

        {/* Platform Cards */}
        <div className="grid md:grid-cols-3 gap-8">
          {platformData.map((platform) => {
            const IconComponent = iconMap[platform.icon];
            return (
              <div
                key={platform.id}
                className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-3xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300 border border-gray-200"
              >
                {/* Icon */}
                <div className="w-16 h-16 rounded-2xl bg-teal-500 flex items-center justify-center mb-6 shadow-lg shadow-teal-500/30">
                  <IconComponent className="w-8 h-8 text-white" />
                </div>

                {/* Platform Name */}
                <h3 className="text-2xl font-bold text-gray-900 mb-2">
                  {platform.name}
                </h3>
                <p className="text-teal-600 font-medium mb-2">
                  {platform.subtitle}
                </p>

                {/* Income */}
                <p className="text-3xl font-bold text-gray-900 mb-6">
                  {platform.income}
                </p>

                {/* Benefits */}
                <ul className="space-y-3">
                  {platform.benefits.map((benefit, idx) => (
                    <li key={idx} className="flex items-start gap-3">
                      <div className="w-5 h-5 rounded-full bg-teal-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                        <div className="w-2 h-2 rounded-full bg-teal-500"></div>
                      </div>
                      <span className="text-gray-700 text-base leading-relaxed">
                        {benefit}
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ValueProposition;
